const CambioIdioma = {
    valida: (var_ingles,ref) => {
        if((ref !== null) && (ref !== undefined) && (ref.current !== null) && (ref.current !== undefined)){ 
            if (ref.current.id === "inputQ"){
                if(var_ingles === "es"){
                    ref.current.placeholder= "Búsqueda..."; 
                }
                else{
                    ref.current.placeholder= "Search...";
                }
            }
            if (ref.current.id == "encabezado_buscar"){
                if(var_ingles === "es"){
                    ref.current.innerHTML= "Buscador"; 
                }
                else{
                    ref.current.innerHTML= "Search"; 
                }
            }
            if (ref.current.id === "pestanaLabel"){
                if(var_ingles === "es"){
                    ref.current.innerHTML= "Colección:"; 
                }
                else{
                    ref.current.innerHTML= "Collection:"; 
                }
            }
            if (ref.current.id === "pestanaLabel2"){
                if(var_ingles === "es"){
                    ref.current.innerHTML= "Orden:"; 
                }
                else{
                    ref.current.innerHTML= "Order:"; 
                }
            }
            if (ref.current.id === "todas"){
                if(var_ingles === "es"){
                    ref.current.innerHTML= "Todas las palabras";
                }
                else{
                    ref.current.innerHTML= "All the words"; 
                }
            }
            if (ref.current.id === "ordenaren"){
                if(var_ingles === "es"){
                    ref.current.innerHTML= "Orden:"; 
                }
                else{
                    ref.current.innerHTML= "Order:"; 
                }
            }
            if (ref.current.id === "cualquiera"){
                if(var_ingles === "es"){
                    ref.current.innerHTML= "Cualquier palabra" 
                }
                else{
                    ref.current.innerHTML= "Any word"; 
                }
            }
            if (ref.current.id === "frase"){
                if(var_ingles === "es"){
                    ref.current.innerHTML= "Frase completa"; 
                }
                else{
                    ref.current.innerHTML= "Complete phrase"; 
                }
            }
            if (ref.current.id === "buscaren"){
                if(var_ingles === "es"){
                    ref.current.innerHTML= "Campos:";
                }
                else{
                    ref.current.innerHTML= "Field:";
                }
            }
            if (ref.current.id === "orderAscdesc"){
                ref.current.children.innerText= var_ingles;
            }
            if (ref.current.id === "BancoBISE"){
                if(var_ingles === "es"){
                    ref.current.innerHTML= "Banco de Indicadores";
                }
                else{
                    ref.current.innerHTML= "Indicators Bank";
                }
            }
            if (ref.current.id === "BancoBIE"){
                if(var_ingles === "es"){
                    ref.current.innerHTML= "Banco de Información Económica (BIE)";
                }
                else{
                    ref.current.innerHTML= "Economic Information Bank (BIE)";
                }
            }
        }
    }
}
export default CambioIdioma